import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const API_BASE = "https://store.wageh.net/blog";

const CardProductGrid = ({ product, onAddToCart }) => {
    const { t } = useTranslation();
    const cleanPath = product.image ? product.image.replace(/^\/+/, '').replace(/^storage\//, '').replace(/^uploads\//, '') : "";
    const imgSrc = product.image
        ? (product.image.startsWith("http") ? product.image : `${API_BASE}/uploads/${cleanPath}`)
        : null;

    const inStock = Number(product.stock) > 0;

    return (
        <div className="card h-100 shadow-sm product-card transition-all">
            <Link to={`/products/${product.id}`}>
                {imgSrc ? (
                    <img
                        src={imgSrc}
                        className="card-img-top p-3"
                        alt={product.name}
                        style={{ height: "220px", objectFit: "contain" }}
                    />
                ) : (
                    <div className="bg-light d-flex align-items-center justify-content-center" style={{ height: "220px" }}>
                        <span className="text-muted">{t("no_image")}</span>
                    </div>
                )}
            </Link>

            {!inStock && (
                <span className="badge bg-danger position-absolute mt-2 mx-2">{t("out_of_stock_badge")}</span>
            )}

            <div className="card-body d-flex flex-column text-center border-top">
                <h6 className="card-subtitle mb-2 text-truncate">
                    <Link to={`/products/${product.id}`} className="text-decoration-none text-dark fw-bold">
                        {product.name}
                    </Link>
                </h6>

                <div className="my-2">
                    <span className="fw-bold h5 text-success">${product.price}</span>
                </div>

                <div className="btn-group d-flex mt-auto" role="group">
                    <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        title={t("add_to_cart_title")}
                        disabled={!inStock}
                        onClick={() => onAddToCart(product.id)}
                    >
                        <i className="bi bi-cart-plus mx-1" /> {t("add_to_cart_btn")}
                    </button>
                    <Link
                        to={`/products/${product.id}`}
                        className="btn btn-sm btn-outline-secondary"
                        title={t("view_details_title")}
                    >
                        <i className="bi bi-eye mx-1" /> {t("details_btn")}
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default CardProductGrid;